import { Action } from "@reduxjs/toolkit";
import { LoginDetails } from "../../types/login";

export const SET_LOGIN = "SET_LOGIN" as const;
export const SET_LOGOUT = "SET_LOGOUT" as const;
export const DASHBOARDKEYSEARCH = "DASHBOARDKEYSEARCH" as const;

export interface SetLoginAction extends Action<typeof SET_LOGIN> {
  payload: LoginDetails;
}

export type SetLogoutAction = Action<typeof SET_LOGOUT>;

export type AuthActions = SetLoginAction | SetLogoutAction;
